import AddCountryFormModal from "./addCountryFormModal";
import AddCurrencyFormModal from "./addCurrencyFormModal";
import AddCompanyTypeFormModal from "./addCompanyTypeFormModal";
import AddRecognizedExchangesFormModal from "./addRecognizedExchangesFormModal";
import AddRegulatoryBodiesFormModal from "./addRegulatoryBodiesFormModal";
import AddSubscriptionFormModal from "./addSubscriptionFormModal";
import AddTooltipsFormModal from "./AddTooltipsFormModal"
const RenderForms = ({table, show, onClose, initialData}) => {
    if (!table) return null;
    if (table === "Country") return <AddCountryFormModal show={show} onClose={onClose} />
    else if (table === "Currency") return <AddCurrencyFormModal show={show} onClose={onClose} />
    else if (table === "CompanyType") return <AddCompanyTypeFormModal show={show} onClose={onClose} />
    else if (table === "RecognizedExchanges") return <AddRecognizedExchangesFormModal show={show} onClose={onClose} />
    else if (table === "RegulatoryBodies") return <AddRegulatoryBodiesFormModal show={show} onClose={onClose} />
    else if (table === "SubscriptionPlan") return <AddSubscriptionFormModal show={show} onClose={onClose} />
     else if (table === "Tooltips")
    return (
      <AddTooltipsFormModal
        show={show}
        onClose={onClose}
        initialData={initialData} // ✅ pass row data
      />
    );
    else return null;
}

export default RenderForms;